import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import {
  AccountManager,
  NotificationManager,
  printMissingConfigError,
  ResponsibleApi,
  SiteConfigManager,
  useAuthorizationEffect,
  useLabel,
} from '@atlas/core';
import { Label, TranslateWithLinks } from '@atlas/ui';

import ConfirmPopup from 'common/Popup/ConfirmPopup';
import { defaultRoutes } from 'components/MainRouter/constants';

const RealityCheckPopup = notification => {
  const { push: historyPush } = useHistory();

  const { id, message, title } = notification;

  const handleLogoutButtonClick = useCallback(() => {
    NotificationManager.removeNotification(id);
    AccountManager.logout();
    historyPush(defaultRoutes.sportPrematch);
  }, [historyPush, id]);

  const handleContinueButtonClick = useCallback(() => {
    NotificationManager.removeNotification(id);
    ResponsibleApi.realityCheckPing();
  }, [id]);

  useAuthorizationEffect(authorization => {
    if (!authorization) {
      NotificationManager.removeNotification(id);
    }
  });

  const realityCheckPopupLink = SiteConfigManager.getConfig(
    'config.config.links.reality_check_popup_link',
  );
  const realityCheckLabel = useLabel(message, { link: realityCheckPopupLink });

  if (!realityCheckPopupLink) {
    printMissingConfigError('config.config.links.reality_check_popup_link');
  }

  return (
    <ConfirmPopup
      data={{
        className: 'reality-check-popup',
        closeLabel: 'signout',
        confirmLabel: 'continue',
        onClose: handleLogoutButtonClick,
        onConfirm: handleContinueButtonClick,
      }}
    >
      <Label className="popup__title" message={title} />
      <div className="popup__text">
        <TranslateWithLinks translate={realityCheckLabel} />
      </div>
    </ConfirmPopup>
  );
};

export default RealityCheckPopup;
